import { render, staticRenderFns } from "./tippszumkauf.vue?vue&type=template&id=6047e962&scoped=true&"
import script from "./tippszumkauf.vue?vue&type=script&lang=js&"
export * from "./tippszumkauf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6047e962",
  null
  
)

export default component.exports